import React, {PureComponent} from 'react';
import './Menu.css';
import TranslatedText from '../../atoms/TranslatedText';
import {ROUTES} from '../../routes';

export default class Menu extends PureComponent {
    render() {
        return (
            <nav className="MenuBottom MenuBottom-hdpolarized">
                <button
                    className={`MenuBottom-button ${
                        this.props.active === 'how-it-works'
                            ? 'MenuBottom-button__active'
                            : ''
                    }`}
                    onClick={() =>
                        this.props.history.push(ROUTES.HDPOLARIZED_CUTSGLARE)
                    }>
                    <TranslatedText tag="hdpolarized.cuts_glare.menu.how-it-works" />
                </button>
                <button
                    className={`MenuBottom-button ${
                        this.props.active === 'axis-of-polarization'
                            ? 'MenuBottom-button__active'
                            : ''
                    }`}
                    onClick={() =>
                        this.props.history.push(
                            ROUTES.HDPOLARIZED_CUTSGLARE_AXIS
                        )
                    }>
                    <TranslatedText tag="hdpolarized.cuts_glare.menu.axis-of-polarization" />
                </button>
            </nav>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/hdpolarized/Menu.js